// extracted by mini-css-extract-plugin
module.exports = {"loadWrap":"src-pages-access-__index__loadWrap--aoscd"};